import { Route, Routes } from "react-router-dom";
import { useState } from "react";

import SME from "./sme";
import StartUp from "./startup";
import Success from "./success";
import Type from "./type";
import Welcome from "./welcome";

const ValuationGame = () => {
  const [values, setValues] = useState({
    company_name: "",
    company_type: "",
    first_name: "",
    last_name: "",
    user_email: "",
    user_phone: "",
    valuation_game: true,
    valuation_game_client_name: "",
    valuation_game_reason: "",
    website_link: "",
    // start-up
    valuation_game_maturity: null,
    valuation_game_funds_sought: null,
    valuation_game_equity_percentage: null,
    valuation_game_strategy: null,
    valuation_game_market: null,
    valuation_game_innovation: null,
    valuation_game_offering: null,
    valuation_game_hr: null,
    valuation_game_finance: null,
    // sme
    valuation_game_creation_year: null,
    valuation_game_sector: null,
    valuation_game_ca: null,
    valuation_game_ebe: null,
  });

  return (
    <div className="relative w-full h-screen flex items-center justify-center overflow-hidden">
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/type" element={<Type values={values} onChange={setValues} />} />
        <Route path="/sme/*" element={<SME values={values} onChange={setValues} />} />
        <Route path="/start-up/*" element={<StartUp values={values} onChange={setValues} />} />
        <Route path="/success" element={<Success />} />
      </Routes>
    </div>
  );
};

export default ValuationGame;
